import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ShareHoc from '@src/components/share';
import { setSharing } from '@store/trends/sharing/actions';
import { currentMetricsMetaSelector } from '@store/common/selectors';
import { sanitizeUserDefinedMetrics } from '@src/utils/metrics/userDefinedMetricsUtils';
import { isAppModule } from '@utils/constants';
import Main from '../main/Main';
import initStore from './initStore';
import AppExperience from '../AppExperience';

function ShareWrapper(props) {
  const dispatch = useDispatch();
  const currentMetricsMeta = useSelector(currentMetricsMetaSelector);
  const applyCallback = (payload) => {
    if (isAppModule) {
      const state = payload.state || {};
      const parsedState = JSON.parse(state);
      const sanitizedState = sanitizeUserDefinedMetrics(parsedState, currentMetricsMeta);
      payload = {
        ...payload,
        state: JSON.stringify(sanitizedState),
      };
    }
    dispatch(setSharing(payload));
  };

  return (
    <ShareHoc {...props} applyCallback={applyCallback} initStore={initStore}>
      {({ store }) =>
        isAppModule ? (
          <AppExperience {...props} isSharing={true} store={store} />
        ) : (
          <Main {...props} isSharing={true} store={store} />
        )
      }
    </ShareHoc>
  );
}

export default ShareWrapper;
